import { render, staticRenderFns } from "./YtDiscoverTab.vue?vue&type=template&id=e87477be&scoped=true&"
import script from "./YtDiscoverTab.vue?vue&type=script&lang=js&"
export * from "./YtDiscoverTab.vue?vue&type=script&lang=js&"
import style0 from "./YtDiscoverTab.vue?vue&type=style&index=0&id=e87477be&lang=scss&scoped=true&"
import style1 from "./YtDiscoverTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87477be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
